module.exports = __webpack_public_path__ + "img/qrcode_100x100.c06d171f.png";